<script setup lang="ts">
import { computed } from 'vue';
import { NxtButton, NxtIconButton, NxtIcon } from '@future-harry/nxt-styles';
import { BlockEditProps } from './block-edit.interface';

const props = defineProps(BlockEditProps);

const emit = defineEmits<{
   (e: 'onSave'): void;
   (e: 'onDiscard'): void;
   (e: 'onRemove'): void;
}>();

const isReady = computed(() => {
   return props.editingBlock?.value && props.editingBlockDefinition?.value && props.draftData?.value;
});
</script>

<template>
   <section v-if="isReady" class="block-edit">
      <NxtButton class="block-edit__icon-label" :button-type="'grey'" @click="emit('onDiscard')">
         <NxtIcon name="plus" size="small" />
         <span>{{ $t('live-editor.add-content-block') }}</span>
      </NxtButton>
      <div class="block-edit__actions">
         <h2>{{ $t(editingBlockDefinition!.value!.i18n.name) }}</h2>
         <NxtIconButton
            v-if="editingBlockDefinition!.value!.isRemovable"
            name="trash"
            hover-color="var(--nxt-grey)"
            @click="emit('onRemove')"
         />
      </div>

      <slot />

      <div class="block-edit__actions">
         <NxtButton name="discard" :button-type="'grey'" @click="emit('onDiscard')">{{ $t('live-editor.discard') }}</NxtButton>
         <NxtButton name="save" @click="emit('onSave')" v-bind="$attrs">{{ $t('live-editor.save') }}</NxtButton>
      </div>
   </section>
</template>

<style lang="scss" scoped>
.block-edit {
   margin-top: var(--nxt-gutter);
   display: flex;
   flex-direction: column;
   gap: var(--nxt-gutter);

   &__icon-label {
      display: flex;
      align-items: center;
      gap: var(--nxt-gutter-small);
      justify-content: center;

      span {
         line-height: var(--nxt-button-height);
      }
   }

   h2 {
      margin: 0;
   }

   &__actions {
      display: flex;
      justify-content: space-between;
      align-items: center;
   }
}
</style>
